<template>
    <b-card v-if="isLoaded">
        <div style="font-size: 24px; text-align: left; margin-bottom: 20px; font-weight: bold;">
            {{getDataTypeName(dataType.name)}}
        </div>
        <div class="table-responsive">
            <table class="table table-hover" style="font-size: 0.875em">
                <thead>
                <tr>
                    <th>{{ $t('priceColumn') }}</th>
                    <th>{{ $t('startDateColumn') }}</th>
                    <th>{{ $t('endDateColumn') }}</th>
                    <th id="unitPrice-last-column" style="width: 9em;"></th>
                </tr>
                </thead>
                <tbody>
                <!-- Update item view -->
                <tr v-for="unitPrice in unitPrices" @keyup.enter="updateItem(unitPrice)" @keyup.esc="bindItems(rawItems)">
                    <td>
                        <template v-if="!unitPrice.editMode">
                            <div>
                                {{ getUnitPrice(unitPrice.price) }}
                            </div>
                        </template>
                        <template v-else>
                            <b-form-input v-model="unitPrice.price.editedValue" type="number" :placeholder="$t('unitPricePlaceHolder')" required/>
                        </template>
                    </td>
                    <td>
                        <template v-if="!unitPrice.editMode">
                            <div>
                                {{ getYear(unitPrice.startDate)}}
                            </div>
                        </template>
                        <template v-else>
                            <b-form-select 
                                v-model="unitPrice.startDate.editedValue" 
                                :options="yearChoices" 
                                @change="setSelectedStartYear($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                        </template>
                        
                    </td>
                    <td>
                        <template v-if="!unitPrice.editMode">
                            <div>
                                {{ getYear(unitPrice.endDate) }}
                            </div>
                        </template>
                        <template v-else>
                            <b-form-select 
                                v-model="unitPrice.endDate.editedValue" 
                                :options="yearChoices" 
                                @change="setSelectedEndYear($event, unitPrice)" style="border-radius: unset !important; height: 100%;"/>
                        </template>
                    </td>                
                    <td :style="{width: lastColumnWidth}" class="edit-column">
                        <div class="tableBodyCell">
                            <div v-if="!unitPrice.editMode" @click="makeRowEditable(unitPrice.id)" style="color: #8888; cursor: pointer">
                                <i class="fas fa-edit"></i>
                            </div>
                            <div :key="'btngroup'" v-else class="table-button-group">
                                <b-button v-b-tooltip.hover :title="$t('save')" @click="updateItem(unitPrice)"><i class="fas fa-check"></i></b-button>
                                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="bindItems(rawItems)"><i class="fas fa-ban"></i></b-button>
                                <b-button v-b-modal.warn v-b-tooltip.hover :title="$t('delete')" @click="deleteItem($event, unitPrice.id)"><i class="fas fa-trash-alt"></i></b-button>
                            </div>
                        </div>
                    </td>
                </tr>
                <transition name="fadere" mode="out-in">
                    <!-- Create item view -->
                    <tr v-if="insertMode" @keyup.enter="createItem()" @keyup.esc="cancelNewRow()" style="border-bottom: 1px solid #ddd">
                        <td>
                            <b-form-input v-model="tempItem.price.editedValue" type="number" :placeholder="$t('unitPricePlaceHolder')" required/>
                        </td>
                        <td>
                            <b-form-select 
                                v-model="tempItem.startDate.editedValue" 
                                :options="yearChoices" 
                                @change="setSelectedStartYear($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                        </td>
                        <td>
                            <b-form-select 
                                v-model="tempItem.endDate.editedValue" 
                                :options="yearChoices" 
                                @change="setSelectedEndYear($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                        </td> 
                        <td class="edit-column" :style="{width: lastColumnWidth}">
                            <div class="table-button-group">
                                <b-button v-b-tooltip.hover :title="$t('save')" @click="createItem()" style="mso-border-shadow: no"><i class="fas fa-check"></i></b-button>
                                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="cancelNewRow()"><i class="fas fa-ban"></i></b-button>
                            </div>
                        </td>
                    </tr>
                </transition>
                <tr v-if="!insertMode && this.$store.state.user.permissions.isAdmin" @click="insertRow()" class="insert-row">
                    <td :colspan="5">
                        <div class="tableBodyCell">
                            <div style="position: absolute; bottom: 56px; left: 0; right: 0; margin:auto">
                                <i class="fas fa-plus-circle fa-2x"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-card>
    <div v-else></div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'admin-unit-price-detail',

    data() {
        return {
            isLoaded: false, // Toggles page loading,
            dataTypes: this.$store.state.dataTypes,
            rawItems: [], // Original dataType object array,
            unitPrices: [],
            siteId: null,
            tempItem: {}, // Temporary object used for inserts
            yearChoices: [
                {
                    value: '2015',
                    text: '2015'
                },
                {
                    value: '2016',
                    text: '2016'
                },
                {
                    value: '2017',
                    text: '2017'
                },
                {
                    value: '2018',
                    text: '2018'
                },
                {
                    value: '2019',
                    text: '2019'
                },
                {
                    value: '2020',
                    text: '2020'
                },
                {
                    value: '2021',
                    text: '2021'
                }
            ],
            insertMode: false,
            lastColumnWidth: '140px'
        };
    },

    methods: {
        routeByTag(tag) {
            this.tags.forEach(tag => {
                tag.active = false;
            });
            tag.active = true;
        },
        getDataTypeName(name) {
            return this.$t(name);
        },
        getYear(date) {
            if (!date.editedValue) {
                return date.substr(0, date.indexOf('-'));
            } else {
                return date.editedValue;
            }
        },
        getUnitPrice(unitPrice) {
            if (!unitPrice.editedValue) {
                return unitPrice;
            } else {
                return unitPrice.editedValue;
            }
        },
        setSelectedStartYear(val, item) {
            item.startDate.editedValue = val;
        },
        setSelectedEndYear(val, item) {
            item.endDate.editedValue = val;
        },
        insertRow() {
            this.insertMode = true;
            this.bindTempItemToView();
            this.bindItems(this.rawItems);
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },

        cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },

        makeRowEditable(unitPriceId) {
            this.cancelNewRow();
            this.bindItems(this.rawItems);
            let unitPrice = _.find(this.unitPrices, {id: unitPriceId});
            unitPrice.editMode = true;
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },

        bindTempItemToView() {
            let tempItem = {
                dataType: {editedValue: 0},
                startDate: {editedValue: 0},
                endDate: {editedValue: 0},
                price: {editedValue: null}
            };
            this.tempItem = tempItem;
        },
        isUnitPriceValid(item) {
            let isValid = true;
            if (
                !item.price.editedValue ||
                !item.startDate.editedValue ||
                !item.endDate.editedValue
            ) {
                this.$toasted.error(this.$t('missingError'));
                isValid = false;
                return isValid;
            }
            if (item.startDate.editedValue >= item.endDate.editedValue) {
                this.$toasted.error(this.$t('duplicateStartEndYear'));
                isValid = false;
                return isValid;
            }
            let duplicateItem = _.find(this.unitPrices, function(o) {
                return o.startDate.value == item.startDate.editedValue && o.id != item.id;
            });
            if (!_.isNil(duplicateItem)) {
                isValid = false;
                this.$toasted.error(this.$t('conflictUnitPriceYear'));
                return isValid;
            }
            return isValid;
        },
        createItem() {
            if (this.isUnitPriceValid(this.tempItem)) {
                let arrangedItem = {
                    dataType: this.dataType.id,
                    price: Number(this.tempItem.price.editedValue),
                    startYear: Number(this.tempItem.startDate.editedValue),
                    endYear: Number(this.tempItem.endDate.editedValue)
                };
                this.$Progress.start();
                return this.axios.post('/unitPrice', arrangedItem).then(({data}) => {
                    let result = data;
                    this.rawItems.push(result);
                    this.bindItems(this.rawItems);
                    this.cancelNewRow();
                    return this.$Progress.finish();
                });
            }
        },

        updateItem(unitPrice) {
            if (this.isUnitPriceValid(unitPrice)) {
                let arrangedItem = {
                    dataType: this.dataType.id,
                    price: unitPrice.price.editedValue,
                    startYear: Number(unitPrice.startDate.editedValue),
                    endYear: Number(unitPrice.endDate.editedValue)
                };
                this.$Progress.start();
                return this.axios.put(`/unitPrice/${unitPrice.id}`, arrangedItem).then(({data}) => {
                    let result = data;
                    let rawItem = _.find(this.rawItems, {id: unitPrice.id});
                    Object.assign(rawItem, result);
                    this.bindItems(this.rawItems);
                    this.cancelNewRow();
                    return this.$Progress.finish();
                });
            }
        },

        deleteItem(event, id) {
            let currentDataType = this.dataType.id;
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios.delete(`/unitPrice/${id}`).catch(() => {
                    this.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                    this.listDataTypes(currentDataType);
                });
                this.rawItems = this.rawItems.filter(item => {
                    return item.id !== id;
                });
                this.bindItems(this.rawItems);
            });
        },

        // Prepare a dataType object to use in dom
        prepareItem(item) {
            let configuredItem = {};
            var startDateInit, endDateInit;
            startDateInit = item.startDate
                ? item.startDate.substr(0, item.startDate.indexOf('-'))
                : '-';
            endDateInit = item.endDate ? item.endDate.substr(0, item.endDate.indexOf('-')) : '-';

            configuredItem.editMode = false;

            configuredItem.id = item.id;
            let name = _.find(this.dataTypes, {id: item.dataType}).name;
            configuredItem.dataTypeId = {
                value: item.dataType,
                editedValue: item.dataType,
                name
            };
            configuredItem.startDate = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endDate = {
                value: endDateInit,
                editedValue: endDateInit
            };
            configuredItem.price = {
                value: item.price,
                editedValue: item.price
            };
            return configuredItem;
        },

        // Bind dataTypes object array to use in dom
        bindItems(unitPrices) {
            //unitPrices.editMode = true;
            this.unitPrices = unitPrices
                .filter(unitPrice => _.find(this.dataTypes, {id: unitPrice.dataType}))
                .map(this.prepareItem);
            return this.calculateLastColumnWidth();
        },

        listDataTypes(dataTypeId) {
            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get(`/unitPrice/${dataTypeId}`).then(({data}) => {
                this.rawItems = data;
                this.bindItems(this.rawItems);
                this.unitPrices = data;
                this.isLoaded = true;
                return this.$Progress.finish();
            });
        },
        calculateLastColumnWidth() {
            return this.$nextTick().then(() => {
                let element = document.getElementById('unitPrice-last-column');
                if (element) {
                    this.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init() {
            this.dataType = _.find(this.dataTypes, {id: this.route.params.type_id});
            this.listDataTypes(this.dataType.id);
        }
    },
    created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
};
</script>

<style lang="scss" scoped>
.fadere-enter-active {
    opacity: 1;
    transition: opacity 0.6s ease;
}
.fadere-enter,
.fadere-leave-to,
.fadere-leave-active {
    opacity: 0;
}
th {
    min-width: 10em;
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
    "tr": {
    "dataTypeName": "Veri tipi",
    "priceColumn": "Birim Fiyatı",
    "unitPricePlaceHolder": "Birim fiyatı",
    "startDateColumn": "Başlangıç Yılı",
    "endDateColumn": "Bitiş Yılı"
    },
    "en": {
    "dataTypeName": "Data type",
    "priceColumn": "Unit Price",
    "unitPricePlaceHolder": "Unit price",
    "startDateColumn": "Start Year",
    "endDateColumn": "End Year"
    }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/UnitPriceDetail.vue